import React from 'react';
import LandingMediaKitMediaLabProduction from '../TNOMediaKitMediaLabProduction/LandingMediaKitMediaLabProduction';
import {
  andreinaRoaMediaLabWho,
  andreinaRoaMediaLabWhy,
  andreinaRoaMediaLabBenefits,
  andreinaRoaMediaLabValues,
  andreinaRoaMediaLabAreYouReady,
} from '../TNOMediaKitMediaLabProduction/andreinaRoaMediaLabContent';

const LandingMediaKitAndreinaRoa = (props) => (
  <LandingMediaKitMediaLabProduction
    {...props}
    proposalSlug="andreina-roa"
    mediaLabContent={{
      who: andreinaRoaMediaLabWho,
      why: andreinaRoaMediaLabWhy,
      benefits: andreinaRoaMediaLabBenefits,
      values: andreinaRoaMediaLabValues,
      areYouReady: andreinaRoaMediaLabAreYouReady,
    }}
  />
);

export default LandingMediaKitAndreinaRoa;
